import React from 'react';
import {AlertCircleIcon} from '../Icons';

/**
 * Shown when the user has a paused subscription and nothing active — Pro limits are gone until they
 * resume, which is easy to mistake for a billing bug otherwise.
 */
const PausedSubscriptionNotice: React.FC = () => {
  return (
    <div className="mt-8 max-w-2xl mx-auto rounded-lg bg-amber-500/10 border border-amber-500/30 p-4">
      <div className="flex items-start gap-3">
        <AlertCircleIcon className="h-5 w-5 text-amber-500 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="text-amber-500 font-semibold mb-1">Subscription Paused</h3>
          <p className="text-gray-300 text-sm">
                        Your subscription is currently paused, so Pro limits do not apply until you resume it.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PausedSubscriptionNotice;
